import { IonSkeletonText } from '@ionic/react'
import React, { FC } from 'react'
import { scoreboardConstants } from '../../../../constants/scoreboardConstants'
import { ScoreboardCardStyle } from '../ScoreboardCard'

interface ScoreboardCardSkeletonProps {
	style?: ScoreboardCardStyle
}

const ScoreboardCardSkeleton: FC<ScoreboardCardSkeletonProps> = ({ style }) => (
	<div
		className={`${scoreboardConstants.card.aspectRatio} p-5 ${scoreboardConstants.card.borderStyle} flex flex-row items-center ${scoreboardConstants.card.roundedStyle} box-border ${
			style?.background ? 'bg-[#e0e0e0] animate-pulse' : (style?.background ?? '')
		}`}
	>
		<div className='h-8 aspect-square flex items-center justify-center'>
			<IonSkeletonText animated className='h-7 w-7 rounded-full' />
		</div>
		<div className='flex flex-col justify-between h-full ml-3 flex-1'>
			<IonSkeletonText animated className='h-6 w-32 mb-2 rounded' />
			<IonSkeletonText animated className='h-4 w-24 rounded' />
		</div>
	</div>
)

export default ScoreboardCardSkeleton
